import React from 'react';

const BrandLinkName = ({ id, name, className, onClick }) => {
  return (
    <a
      href={`${window.origin}/#/brands?brand=${id}`}
      rel="noopener noreferrer"
      onClick={onClick}
      className={className}
    >
      {name}
    </a>
  );
};

export default BrandLinkName;
